import React from "react";

// Reusable sparkle/star icon (from user-supplied Icon.svg).
// `size` in px, `color` applies to the path fill.
export const Sparkle = ({ size = 18, color = "var(--yellow-deep)", className = "", style = {} }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        style={style}
        aria-hidden="true"
    >
        <path
            d="M36 16L33.5 10.5L28 8L33.5 5.5L36 0L38.5 5.5L44 8L38.5 10.5L36 16ZM36 44L33.5 38.5L28 36L33.5 33.5L36 28L38.5 33.5L44 36L38.5 38.5L36 44ZM16 38L11 27L0 22L11 17L16 6L21 17L32 22L21 27L16 38ZM16 28.3L18 24L22.3 22L18 20L16 15.7L14 20L9.7 22L14 24L16 28.3Z"
            fill={color}
        />
    </svg>
);
